'use client';

import { useState } from 'react';
import { useQuery, useMutation } from '@apollo/client/react';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import { makeStyles } from 'tss-react/mui';
import { myDiscordLinkQuery, unlinkDiscordMutation } from '../../apollo/discord';

const useStyles = makeStyles()((theme) => ({
  discordInfo: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    marginTop: theme.spacing(1),
  },
  username: {
    fontWeight: 500,
  },
}));

const DiscordLinkSection = () => {
  const { classes } = useStyles();
  const [error, setError] = useState<string | null>(null);

  const { data, loading } = useQuery(myDiscordLinkQuery, { ssr: false });
  const [unlinkDiscord, { loading: unlinking }] = useMutation(unlinkDiscordMutation, {
    refetchQueries: [{ query: myDiscordLinkQuery }],
    onError: (err) => setError(err.message),
  });

  const discordLink = data?.me?.discordLink;

  if (loading || !discordLink) {
    return null;
  }

  const handleUnlink = async () => {
    setError(null);
    await unlinkDiscord();
  };

  return (
    <Box sx={{ mb: 2 }}>
      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}
      {discordLink.isLinked ? (
        <div className={classes.discordInfo}>
          <Typography>
            Discord: <span className={classes.username}>{discordLink.discordUsername}</span>
          </Typography>
          <Button
            variant="outlined"
            size="small"
            color="error"
            onClick={handleUnlink}
            disabled={unlinking}
          >
            Unlink
          </Button>
        </div>
      ) : (
        <Typography color="text.secondary">
          Your Discord account was previously connected but is now disconnected.
          Use the <strong>/er-link</strong> command in Discord to reconnect.
        </Typography>
      )}
    </Box>
  );
};

export default DiscordLinkSection;
